"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createDeferred;

function createDeferred() {
  var reject, resolve;
  var promise = new Promise(function (promiseResolve, promiseReject) {
    reject = promiseReject;
    resolve = promiseResolve;
  });

  if (!reject || !resolve) {
    throw new Error('Promise is not a ES-compliant and do not run exector immediately');
  }

  return {
    promise: promise,
    reject: reject,
    resolve: resolve
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jcmVhdGVEZWZlcnJlZC5qcyJdLCJuYW1lcyI6WyJjcmVhdGVEZWZlcnJlZCIsInJlamVjdCIsInJlc29sdmUiLCJwcm9taXNlIiwiUHJvbWlzZSIsInByb21pc2VSZXNvbHZlIiwicHJvbWlzZVJlamVjdCIsIkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQWUsU0FBU0EsY0FBVCxHQUEwQjtBQUN2QyxNQUFJQyxNQUFKLEVBQVlDLE9BQVo7QUFFQSxNQUFNQyxPQUFPLEdBQUcsSUFBSUMsT0FBSixDQUFZLFVBQUNDLGNBQUQsRUFBaUJDLGFBQWpCLEVBQW1DO0FBQzdETCxJQUFBQSxNQUFNLEdBQUdLLGFBQVQ7QUFDQUosSUFBQUEsT0FBTyxHQUFHRyxjQUFWO0FBQ0QsR0FIZSxDQUFoQjs7QUFLQSxNQUFJLENBQUNKLE1BQUQsSUFBVyxDQUFDQyxPQUFoQixFQUF5QjtBQUN2QixVQUFNLElBQUlLLEtBQUosQ0FBVSxrRUFBVixDQUFOO0FBQ0Q7O0FBRUQsU0FBTztBQUFFSixJQUFBQSxPQUFPLEVBQVBBLE9BQUY7QUFBV0YsSUFBQUEsTUFBTSxFQUFOQSxNQUFYO0FBQW1CQyxJQUFBQSxPQUFPLEVBQVBBO0FBQW5CLEdBQVA7QUFDRCIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZURlZmVycmVkKCkge1xuICBsZXQgcmVqZWN0LCByZXNvbHZlO1xuXG4gIGNvbnN0IHByb21pc2UgPSBuZXcgUHJvbWlzZSgocHJvbWlzZVJlc29sdmUsIHByb21pc2VSZWplY3QpID0+IHtcbiAgICByZWplY3QgPSBwcm9taXNlUmVqZWN0O1xuICAgIHJlc29sdmUgPSBwcm9taXNlUmVzb2x2ZTtcbiAgfSk7XG5cbiAgaWYgKCFyZWplY3QgfHwgIXJlc29sdmUpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoJ1Byb21pc2UgaXMgbm90IGEgRVMtY29tcGxpYW50IGFuZCBkbyBub3QgcnVuIGV4ZWN0b3IgaW1tZWRpYXRlbHknKTtcbiAgfVxuXG4gIHJldHVybiB7IHByb21pc2UsIHJlamVjdCwgcmVzb2x2ZSB9O1xufVxuIl19